import { render, staticRenderFns } from "./AccountConfiguration.vue?vue&type=template&id=91edad8e&scoped=true&"
import script from "./AccountConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AccountConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91edad8e",
  null
  
)

export default component.exports